import { render, staticRenderFns } from "./LojaRepresView.vue?vue&type=template&id=6969746c&scoped=true"
import script from "./LojaRepresView.vue?vue&type=script&lang=js"
export * from "./LojaRepresView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969746c",
  null
  
)

export default component.exports